import { __awaiter } from '../../_virtual/_tslib.js';
import { HttpMethod } from '@hub-la/fe-core-http-client';
import { Envs } from '../envs.js';

class GetMembersArea {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(values) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        const response = yield this.httpClient.request({
          url: `${Envs.BFF_MEMBERS_AREA_URL}/products/${values.productId}/settings/members-area`,
          method: HttpMethod.GET,
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json'
          }
        });
        return response.data;
      } catch (error) {
        throw new Error('Error get members area');
      }
    });
  }
}

export { GetMembersArea };
